// Once-per-device flag for the "version uploaded" popup shown after the
// first successful upload of a session in the Generation view (2026-09-15).
// Expiry, legacy migration and blocked-storage rules live in onceFlag.ts
// (shared with the Welcome popup and the star hint).

import { hasSeenOnceFlag, markOnceFlagSeen } from './onceFlag';

export const FIRST_UPLOAD_HINT_KEY = 'vs-first-upload-hint-v1';

export function hasSeenFirstUploadHint(storage?: Storage): boolean {
  return hasSeenOnceFlag(FIRST_UPLOAD_HINT_KEY, storage);
}

export function markFirstUploadHintSeen(storage?: Storage): void {
  markOnceFlagSeen(FIRST_UPLOAD_HINT_KEY, storage);
}
